/**
 * Rückmeldung an der Kasse (POS-02): kurzer Ton und Haptik (`haptics.ts`, auch unter iOS in der App), damit man beim Scannen nicht auf den Bildschirm schauen
 * muss. Beides ist freiwillig (ohne Unterstützung passiert nichts) und nie Voraussetzung für den Ablauf.
 */
import { haptics } from './haptics';
import { readSound } from './sound';

let context: AudioContext | null = null;

/**
 * Entsperrt den Ton (K8): Browser lassen Audio erst nach einer Nutzergeste zu. Die Kasse ruft das beim ersten Tipp auf;
 * ein Scan mit der Kamera ist keine Geste, dort bliebe der Ton sonst stumm. Legt den Kontext an und setzt ihn fort.
 */
export function unlockAudio(): void {
  try {
    if (typeof AudioContext === 'undefined') return;
    context ??= new AudioContext();
    if (context.state === 'suspended') void context.resume().catch(() => undefined);
  } catch {
    // Ton nicht verfügbar
  }
}

/** Dauer des Ein- und Ausblendens: ohne sie knackt der Ton am Anfang und Ende. */
const FADE_S = 0.008;

function beep(frequencyHz: number, durationMs: number): void {
  if (!readSound()) return;
  try {
    if (typeof AudioContext === 'undefined') return;
    context ??= new AudioContext();
    if (context.state === 'suspended') void context.resume().catch(() => undefined);
    const oscillator = context.createOscillator();
    const gain = context.createGain();
    const start = context.currentTime;
    const end = start + durationMs / 1000;
    oscillator.frequency.value = frequencyHz;
    gain.gain.setValueAtTime(0, start);
    gain.gain.linearRampToValueAtTime(0.08, start + FADE_S);
    gain.gain.setValueAtTime(0.08, Math.max(start + FADE_S, end - FADE_S));
    gain.gain.linearRampToValueAtTime(0, end);
    oscillator.connect(gain);
    gain.connect(context.destination);
    oscillator.start(start);
    oscillator.stop(end + FADE_S);
  } catch {
    // Ton nicht verfügbar
  }
}

export function signalSuccess(): void {
  beep(880, 90);
  haptics.success();
}

export function signalWarning(): void {
  beep(440, 160);
  haptics.warning();
}

export function signalError(): void {
  beep(220, 260);
  haptics.error();
}

/** Kurzes Antippen-Gefühl (Wischschwelle erreicht): nur Haptik, kein Ton. */
export function signalTick(): void {
  haptics.tick();
}

/** Kurzer Ton beim Einschalten des Tons: Man hört sofort, dass er geht (zählt zugleich als Entsperren). */
export function signalSoundOn(): void {
  unlockAudio();
  beep(660, 70);
}
